import Vue from 'vue'
import "@fontsource/roboto/100.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";
import App from './App'
import store from './store'
import moment from "moment"
import router from './router'
import text from "./core/text"
//import './registerServiceWorker'
import Tab from './components/layout/Tab'
import Tabs from './components/layout/Tabs'
import Label from './components/base/Label'
import Radio from './components/base/Radio'
import Ripple from './components/base/Ripple'
import Checkbox from './components/base/Checkbox'
import Input from './components/base/input/Input'
import SideBar from "./components/layout/SideBar"
import Button from './components/base/input/Button'
import { sso, staff, common } from './core/api/index'
import Dropdown from './components/base/input/Dropdown'
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { fas, faCheck } from "@fortawesome/free-solid-svg-icons"
import Datepicker from "./components/base/datepicker/Datepicker"
import InputDatepicker from "./components/base/input/Datepicker.vue"
import StationDropdown from './components/base/input/StationDropdown'
import DateRangePicker from "./components/base/datepicker/DateRangePicker"

// import './core/mockData'
// import { setup } from 'mockjs'
// setup({ timeout: 15 });


library.add(fas, faCheck)

Vue.prototype.$sso = sso;
Vue.prototype.$text = text;
Vue.prototype.$api = common;
Vue.prototype.$staff = staff;
Vue.config.productionTip = false;
[Tab,
  Tabs,
  Input,
  Radio,
  Label,
  Ripple,
  Button,
  SideBar,
  Checkbox,
  Dropdown,
  Datepicker,
  InputDatepicker,
  DateRangePicker,
  StationDropdown,
  FontAwesomeIcon]
  .forEach(x => Vue.component(x.name, x));

// timestamp 須為 Number
Vue.filter('toDateString', (input, format = "YYYY-MM-DD") => moment(input).format(format));

try {
  const beta = new URLSearchParams(window.location.search).get('beta');
  if (beta === 'true') sessionStorage.setItem('beta', 'true');
  else if (beta !== null) sessionStorage.removeItem('beta');
} catch (e) { 
  console.error(e);
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
